.body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

/* Текст шага держит одну и ту же высоту: без этого панель подпрыгивала бы на
   каждом переходе, потому что подписи шагов разной длины. */
.text {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  min-height: 5.4em;
}

.stepTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--text);
}

.stepText {
  max-width: 62ch;
  color: var(--text-2);
  font-size: var(--fs-md);
}

/* Подвал модала прижимает содержимое вправо — здесь нужен весь ряд:
   «пропустить» слева, точки по центру, кнопки справа. */
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-5);
  width: 100%;
}

.skip {
  padding: 0;
  background: transparent;
  border: none;
  color: var(--text-3);
  font-size: var(--fs-sm);
  cursor: pointer;
}

.skip:hover {
  color: var(--text-2);
  text-decoration: underline;
}

.dots {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

/* Точка — не только индикатор, но и переход: тур листают и назад тоже,
   а перебирать шаги кнопкой ради этого утомительно. */
.dot {
  width: 8px;
  height: 8px;
  padding: 0;
  background: var(--border-strong);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition:
    background var(--panel-dur) var(--dnd-ease),
    transform var(--panel-dur) var(--dnd-ease);
}

.dot:hover {
  background: var(--text-3);
}

.dotActive {
  background: var(--text);
  transform: scale(1.35);
}

.nav {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ───────
   «Пропустить» уходит: закрыть тур можно крестиком в шапке, а ряд из трёх
   групп на такой ширине не встаёт. */
@media (max-width: 720px) {
  .skip {
    display: none;
  }

  .footer {
    gap: var(--sp-4);
  }

  .text {
    min-height: 7em;
  }
}

@media (prefers-reduced-motion: reduce) {
  .dot {
    transition: none;
  }
}
